// =============================================
// File: src/config/axiosConfig.js
// =============================================

import axios from "axios";
import { message } from "antd";

// Base URL - Change this to your actual API endpoint
// const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:9000/api";
// const BASE_URL = 'https://52.66.115.4:9000/api'

const BASE_URL = "https://kittynmice.com/api";
// const BASE_URL = "http://localhost:9000/api";

// Create axios instance with default config
const axiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 120000, // 120 seconds (2 minutes) for large file uploads
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// Request interceptor for auth token
axiosInstance.interceptors.request.use(
  (config) => {
    // Get token from localStorage or your auth state
    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Add timestamp to prevent caching issues
    if (config.method === "get") {
      config.params = {
        ...config.params,
        _t: new Date().getTime(),
      };
    }

    return config;
  },
  (error) => {
    console.error("Request error:", error);
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
axiosInstance.interceptors.response.use(
  (response) => {
    // Any status code that lies within the range of 2xx causes this function to trigger
    return response.data;
  },
  (error) => {
    const { response } = error;

    if (response) {
      switch (response.status) {
        case 401:
          // Unauthorized - redirect to login
          message.error("Session expired. Please login again.");
          localStorage.removeItem("authToken");
          // Redirect to login page
          window.location.href = "/login";
          break;

        case 403:
          message.error("You do not have permission to perform this action.");
          break;

        case 404:
          message.error("Requested resource not found.");
          break;

        case 413:
          // Payload Too Large - file size exceeded
          message.error(
            "File size too large. Please reduce image sizes and try again. Maximum 10MB per image."
          );
          break;

        case 422:
          // Validation errors
          if (response.data.errors) {
            const errorMessages = Object.values(response.data.errors)
              .flat()
              .join(", ");
            message.error(errorMessages);
          } else {
            message.error("Validation error occurred.");
          }
          break;

        case 500:
          message.error("Internal server error. Please try again later.");
          break;

        default:
          message.error(response.data.message || "An error occurred.");
      }
    } else if (error.request) {
      // Request was made but no response received
      message.error("Network error. Please check your internet connection.");
    } else {
      // Something else happened
      message.error("An unexpected error occurred.");
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
